import { blockType } from "../constants";
import { KanbanBlockSchema } from "../schema";
import type { Kanban } from "../types";

export const map: Kanban["map"] = (block) => {
  return {
    type: blockType,
    config: {
      ...KanbanBlockSchema.shape.config.parse(block.config),
      id: block.id,
    },
    stateId: block.blockState?.id,
  };
};
